import React, { useState, useEffect } from "react"
import { useParams, useNavigate } from "react-router-dom"

import { Rating } from "primereact/rating";
import { Tooltip } from "primereact/tooltip";

import UnitPriceScoreChart from "./Components/UnitPriceScore";
import ScoresChart from "./Components/ScoresChart";
import DualAxisChart from "./Components/DualAxisChart";
import ProductList from "./Components/ProductList";
import Loading from "../../common/Loading";

import { getSellerProfileDataById } from "../../services/api/sellerProfile";
import Steps from "../../helpers/Steps";


const SellerCompany = (props) => {
    const { id } = useParams()
    const navigate = useNavigate()

    const [companyName, setCompanyName] = useState('')
    const [companyAddr, setCompanyAddr] = useState('')
    const [top3Branches, setTop3Branches] = useState([])
    const [categoryBrandMapObj, setCategoryBrandMapObj] = useState({})
    const [top10Products, setTop10Products] = useState([])
    const [last6MonthSalesProfitData, setLast6MonthSalesProfitData] = useState([])
    const [leadScoreData, setLeadScoreData] = useState([])
    const [unitPriceData, setUnitPriceData] = useState([])
    const [deliveryAdherence, setDeliveryAdherence] = useState(null)
    const [isLoaderVisible, setIsLoaderVisible] = useState(true)
    const [hodDetails, setHodDetails] = useState({})

    useEffect(() => {
        getSellerProfileData()
    }, [])

    const items = [
        {
            label: 'Company Details',
            command: () => { navigate(`/company/${id}`); }
        },
        {
            label: 'Users',
            command: () => { navigate(`/company/users/${id}`); }
        },
        {
            label: 'Branch',
            command: () => { navigate(`/company/branches/${id}`); }
        },
        {
            label: 'Bank Accounts',
            command: () => { navigate(`/company/bank_details/${id}`); }
        },
        {
            label: 'Rate Contract',
            command: () => { navigate(`/company/ratecontract/${id}`); }
        },
        {
            label: 'Seller Profile',
            command: () => { navigate(`/company/seller-profile/${id}`); } 
        }
    ]

    const getSellerProfileData = async () => {
        setIsLoaderVisible(true)

        const response = await getSellerProfileDataById(id)
        if (!response?.failure) {
            const data = response?.data
            setCompanyName(data?.companyDetail?.[0]?.companyName)
            setCompanyAddr(data?.companyDetail?.[0]?.addr)
            setTop3Branches(data?.top3Branches)

            setCategoryBrandMapObj(data?.top3CategoryAndBrand)
            setTop10Products(data?.top10Products)
            setLeadScoreData(data?.leadScoreData)
            setUnitPriceData(data?.unitPriceData)
            setDeliveryAdherence(data?.deliveryAdherence?.[0]?.deliveryAdherenceScore)
            
            const hodData = data?.hodDetail[0]
            setHodDetails(Object.values(hodData).every(value => value === null || value === ' ') ? {} : hodData)
            setLast6MonthSalesProfitData(data?.last6MonthSalesProfitData)

            setIsLoaderVisible(false)
        }
    }

    return (
        <div className="container seller-company-container gap-3 mb-5 relative" >
            <div className="company-step-header" style={{ top: 50 }}>
                <Steps model={items} activeIndex={5} readOnly={false} />
            </div>
            <div className="p-card mb-1" style={{ borderTopLeftRadius: "0px", borderTopRightRadius: "0px"}}>
                <h4 style={{ textAlign: "left" }}><span className="text-blue-800">{companyName}</span></h4>
                <p className=""><i className="pi pi-building" style={{ fontSize: '1rem' }}></i><span className="ml-2">{companyAddr}</span></p>
            </div>
            <div className="flex flex-row col-12 px-0 gap-2">
                {Object.keys(hodDetails)?.length > 0 && 
                    <div className="p-card col-7 pr-0 mb-1 pb-1">
                        <h4><i className="pi pi-user" style={{ fontSize: '1rem' }}></i><span className="ml-2 text-blue-800">HOD</span></h4>
                        <p className="pl-3"><span>{hodDetails?.hodname}</span><br></br>{hodDetails?.emailId}<br></br>{hodDetails?.phoneNumber}<br></br></p>
                    </div>
                }
                {top3Branches?.length > 0 && 
                    <div className="p-card  pr-0 mb-1 w-full pb-1">
                        <h4><i className="pi pi-sitemap" style={{ fontSize: '1rem' }}></i><span className="ml-2 text-blue-800">PM Branch</span></h4>
                        <ul>
                            {top3Branches.map(branch => (
                                <li key={branch}>{branch}</li>
                            ))}
                        </ul>
                    </div>
                }
            </div>
            {Object.keys(categoryBrandMapObj).length>0 && 
                <div className="p-card mb-1 pb-1">
                    <h4><i className="pi pi-th-large" style={{ fontSize: '1rem' }}></i><span className="ml-2 text-blue-800">Top 3 Categories with Top 3 Brands</span></h4>
                    <div className="flex flex-row col-12 justify-content-center">
                        {Object.keys(categoryBrandMapObj).map((category, index) => (
                            <div className="col-3 p-card bg-gray-100 ml-3" key={index}>
                                <h5>{category}</h5>
                                <ul style={{ listStyleType: 'square' }}>
                                    {categoryBrandMapObj[category].slice(0, 3).map((brand, brandIndex) => (
                                        <li key={brandIndex}>{brand}</li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
            }
            {
                top10Products?.length > 0 &&             
                <div className="p-card mb-1 mt-2 pb-1">
                    <h4><i className="pi pi-box" style={{ fontSize: '1rem' }}></i><span className="ml-2 text-blue-800">Top 10 Product</span></h4>
                    <ProductList top10Products={top10Products}/>
                </div>
            }
            {
                deliveryAdherence &&
                <div className="p-card mb-1 mt-2 pb-1">
                    <h4> <i style={{ fontSize: '1rem', color: '#1eb0b3' }}></i><span className=" text-blue-800">Adherence Score<i className="pi pi-info-circle ml-1 custom-tooltip-adherence-score"></i></span></h4>
                    <Tooltip target=".custom-tooltip-adherence-score" position='right'>
                        <span>This score represents the quality of a vendor's deliveries.</span>
                    </Tooltip>
                    <Rating stars={deliveryAdherence} value={deliveryAdherence} readOnly cancel={false} />
                </div>
            }
            {
                last6MonthSalesProfitData?.length > 0 &&
                <div className="">
                    <div className="flex flex-row col-12 px-0 gap-2">
                        <div className="col-6 p-card mb-1 pb-1">
                            <h4><i style={{ fontSize: '1rem' }}></i><span className="ml-2 text-blue-800">Sales and Profit Chart<i className="pi pi-info-circle ml-1 custom-tooltip-sales-data"></i></span></h4>
                            <Tooltip target=".custom-tooltip-sales-data" position='right'>
                                <span>This chart represents the last 6 month sales and profit data.</span>
                            </Tooltip>
                            <DualAxisChart last6MonthSalesProfitData={last6MonthSalesProfitData} />
                        </div>
                        <div className="p-card mb-1 w-full pr-0 pb-1">
                        <h4><i style={{ fontSize: '1rem' }}></i><span className="ml-2 text-blue-800">Lead Time Score<i className="pi pi-info-circle ml-1 custom-tooltip-lead-score"></i></span></h4>
                            <Tooltip target=".custom-tooltip-lead-score" position='right'>
                                <span>This score represents the quote, actual, and deviation from the lead time score for the present vendor and their competitive vendors.</span>
                            </Tooltip>
                            <ScoresChart leadScoreData={leadScoreData} />
                        </div>
                    </div>
                </div>
            }
            {
                unitPriceData?.length > 0 && 
                <div className="p-card">
                    <h4> <i style={{ fontSize: '1rem' }}></i><span className="ml-2 text-blue-800">Unit Price Score <i className="pi pi-info-circle ml-1 custom-tooltip-unit-price"></i></span></h4>
                    <Tooltip target=".custom-tooltip-unit-price" position='right'>
                        <span>This score represents the quote, PO, and Negotiation unit price score for the present vendor and their competitive vendors.</span>
                    </Tooltip>
                    <UnitPriceScoreChart unitPriceData={unitPriceData}/>
                </div>
            }
            <Loading visible={isLoaderVisible} /> 
        </div>
    )
}

export default SellerCompany;